import { Drawer, Link } from '@one-thd/sui-atomic-components';
import React, { useEffect, useState } from 'react';
import { EditDeliveryAddressDrawerContent } from './EditDeliveryAddressDrawerContent';
import { TrackEditDeliveryAddressAnalytics } from '../../../utils/edit-delivery-address/analytics';
export var EditDeliveryAddress = function (_a) {
    var setShowDrawerError = _a.setShowDrawerError;
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    var _c = useState(false), isOuterClick = _c[0], setIsOuterClick = _c[1];
    useEffect(function () {
        TrackEditDeliveryAddressAnalytics('purchase history: order details: edit delivery address displayed', 'button submission');
    }, []);
    return (React.createElement("div", { className: "card-fix" },
        React.createElement(Link, { component: "button", variant: "body-base", onClick: function () {
                setOpen(true);
                TrackEditDeliveryAddressAnalytics('edit delivery address overlay', 'overlay');
            } }, "Edit"),
        open && (React.createElement(Drawer, { open: open, onClose: function () {
                setIsOuterClick(true);
            } },
            React.createElement(EditDeliveryAddressDrawerContent, { setOpen: setOpen, setShowDrawerError: setShowDrawerError, isOuterClick: isOuterClick, setIsOuterClick: setIsOuterClick })))));
};
